//@flow

import sv_SE from "./sv_SE"
import en_GB from "./en_GB"
import nb_NO from "./nb_NO"
import fi_FI from "./fi_FI"

export const LANGUAGES = {
  SV: sv_SE.name,
  EN: en_GB.name,
  NO: nb_NO.name,
  FI: fi_FI.name
}

export const DEFAULT_LANGUAGE = LANGUAGES.SV

export default ({
  [LANGUAGES.SV]: sv_SE,
  [LANGUAGES.EN]: en_GB,
  [LANGUAGES.NO]: nb_NO,
  [LANGUAGES.FI]: fi_FI
}: { ... })
